<script lang="ts">
  import type { FormEventHandler } from "svelte/elements";

	export let value: string | null;
	export let placeholder: string = 'Search';
	export let classes: string = '';
	export let onFocus = (e:any) => {};
	export let onblur = () => {};
	export let onInput: FormEventHandler<HTMLInputElement> | undefined | null = null;
	export let clear: () => string | void = () => value = '';
	export let loading = false;
  let inp: HTMLInputElement;
</script>

<div class="search {classes}" data-testid="search-box">
	<label class:load={loading}>
		<span class="search-icon icon-search-28"></span>
		<input bind:this={inp} type="search" name="search" autocomplete="off" {placeholder} data-testid="search-input"
		bind:value
		on:focus={onFocus}
		on:input={onInput}
		on:blur={onblur}>
	</label>
	{#if value?.length}
	<!--
		NOTE on the order of focus and clear. Nav attempts to modify the URL on both clear
		and onFocus. If onFocus is called last it undoes what clear tried to do. I (GW) would
		prefer the focus not to be called here.
	-->
	<button on:click={() => { inp.focus(); clear(); }}>
		<span class="icon-clear-circle-20"></span>
	</button>
	{/if}
</div>

